import { toast } from "sonner";

/**
 * Raised by a screen action that has no endpoint on the new backend yet.
 *
 * The old Xano calls are blocked in the browser (see NotMigratedError in
 * service/index.ts), and a blocked call used to end in a spinner or a table
 * that read "No results". An action with no replacement now says so, in words
 * the operator can read, and stops. It never reports success and never sends
 * anything to the server.
 */
export class NotAvailableYetError extends Error {
  readonly feature: string;
  constructor(feature: string) {
    super(`${feature} is not available yet.`);
    this.name = "NotAvailableYetError";
    this.feature = feature;
  }
}

/**
 * Tells the operator, then throws so the caller's own error path runs and no
 * success state is shown. The toast carries a fixed id per feature, so a
 * caller that also toasts its own failure does not stack duplicates.
 */
export function notAvailable(feature: string): never {
  const error = new NotAvailableYetError(feature);
  toast.error("Not available yet", {
    id: `not-available-${feature}`,
    description: error.message,
  });
  throw error;
}
